import React, { useState, useEffect } from 'react';
import { BarChart3, Target, Users } from 'lucide-react';
import { getDashboardAnalytics } from '../services/analyticsService';
import MetricCard from './charts/MetricCard';
import SimpleBarChart from './charts/SimpleBarChart';

const DashboardAnalyticsSection = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const endDate = new Date().toISOString().split('T')[0];
        const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
        const result = await getDashboardAnalytics({ startDate, endDate });
        setData(result);
      } catch (err) {
        console.error('Dashboard analytics fetch failed:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  if (loading) {
    return (
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {[1, 2, 3].map(i => (
            <div key={i} className="bg-white rounded-lg p-4 shadow-sm animate-pulse">
              <div className="h-3 bg-gray-200 rounded w-20 mb-2"></div>
              <div className="h-6 bg-gray-200 rounded w-16"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!data) return null;

  const { proposals, relevance, submissions } = data;
  const dailyData = submissions?.daily || [];
  const skillData = relevance?.skillMatches || [];

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-900">Analytics Overview (Last 30 Days)</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <MetricCard
          title="Total Proposals"
          value={proposals?.totalProposals || 0}
          icon={BarChart3}
          color="blue"
        />
        <MetricCard
          title="Success Rate"
          value={`${proposals?.successRate || 0}%`}
          icon={Target}
          color="green"
        />
        <MetricCard
          title="Response Rate"
          value={`${proposals?.responseRate || 0}%`}
          icon={Users}
          color="purple"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <SimpleBarChart
          title="Proposal Trends"
          data={dailyData.map(item => ({
            label: new Date(item.date).toLocaleDateString(),
            value: item.count
          }))}
        />
        <SimpleBarChart
          title="Top Skills"
          data={skillData.slice(0, 5).map(item => ({
            label: item.skill,
            value: item.matches
          }))}
        />
      </div>
    </div>
  );
};

export default DashboardAnalyticsSection;
